import { IConfig } from '@cian/config/shared';

import { IGetInfrastructureResponse } from 'shared/repositories/infrastructure-caching/v4/get-infrastructure';
import { IInfrastructureCategory, IInfrastructureItem } from 'shared/types/infrastructure';

interface IParams {
  response: IGetInfrastructureResponse;
  config: IConfig;
  regionId: number;
}

export const prepareInfrastructure = ({
  response: {
    infrastructure: { order, items },
  },
  config,
  regionId,
}: IParams): IInfrastructureCategory[] => {
  // Получаем иконки объектов инфраструктуры
  const infrastructureIcons = config.get<Partial<Record<string, string>>>('audience.infrastructureIcons');

  if (!infrastructureIcons) {
    return [];
  }

  const getIcon = (key: string) => infrastructureIcons[key]?.replace(/{{regionId}}/, String(regionId));

  // Группируем элементы по типам
  const groupedItems = items.reduce<Record<string, IInfrastructureItem[]>>((result, item) => {
    const icon = getIcon(item.kind || item.type);

    if (!icon) {
      return result;
    }

    const categoryItems = result[item.type] || [];
    // Расширяем объект инфраструктуры иконкой
    const extendedItem: IInfrastructureItem = { ...item, icon };

    return {
      ...result,
      [item.type]: [...categoryItems, extendedItem],
    };
  }, {});

  // Возвращаем отсортированный список категорий с группированными элементами
  return order
    .map(type => {
      const items = groupedItems[type];

      if (!items) {
        return null;
      }

      return { title: items[0].typeName, type, items, icon: getIcon(type) };
    })
    .filter(Boolean) as IInfrastructureCategory[];
};
